import { Editor, Path, Transforms } from 'slate';
import { isExpanded, getNodes } from '@udecode/slate-plugins';
import { BLOCK_TABLE, BLOCK_TABLE_CELL } from '../types';
import { getEmptyTableCell } from '../utils/get-empty-table-cell';

export const splitCells = (editor) => {
  const isRange = isExpanded(editor.selection);
  const currentCells = isRange ? Array.from(Editor.nodes(editor, {
    match: n => n.type === BLOCK_TABLE_CELL,
  })) : [Editor.above(editor, {
    match: n => n.type === BLOCK_TABLE_CELL,
  })];
  if (currentCells) {
    console.log({currentCells})
    // const colspan = currentCells.length;
    // const [,mainCellPath] = currentCells.shift();

    // Transforms.setNodes(
    //   editor,
    //   {
    //     colspan,
    //   },
    //   {
    //     at: mainCellPath,
    //   },
    // );

    // console.log({mainCellPath})
    currentCells.map((cell) => {
      const [cellNode, cellPath] = cell;

      if (cellNode.colspan > 1) {
        Transforms.setNodes(editor, {
          colspan: 1
        }, {
          at: cellPath
        })
        const last = cellPath.pop()
        Array.from(Array(cellNode.colspan - 1).keys()).map(n => {
          Transforms.insertNodes(editor, getEmptyTableCell(), {
            at: [...cellPath, cellPath[last] + 1]
          })
        })
      }
      
    })
      
  }
};